// component/FiltrerTransactionModal.js
import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
  ButtonGroup,
} from "reactstrap";
import '../utils/detail.css';
const FiltrerMerchentModal = ({ isOpen, toggle, onApply, countries = [] }) => {
  const [active, setActive] = useState("");
  const [ kycStatus, setKycStatus] = useState("");
  const [selectedCountrie, setSelectedCountrie] = useState("");
  const [createdDate, setCreatedDate] = useState("")
  const [approvalDate, setApprovalDate] = useState("")
  const [kycVerified, setKycVerified] = useState("")
  const [minBalance, setMinBalance] = useState("");
  const [maxBalance, setMaxBalance] = useState("");
  const applyFilters = () => {
    onApply({
      kycStatus,
      active,
      countrie: selectedCountrie,
      createdDate,
      approvalDate,
      kycVerified,
      minBalance,
      maxBalance,
    });
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} contentClassName="custom-modal-siMerchent">
      <ModalHeader toggle={toggle} className="custom-modal-header"style={{color:'#000000'}}>
        Filtrer
      </ModalHeader>
      <ModalBody>
    <div className=" ">
   <div className="d-flex align-items-center me-3">
    <label className=" mb-0 me-2 lanel">Statut</label>
    <div style={{ width: "100%", border:'1px solid #0000001A' }}></div>
  </div>
  <ButtonGroup className="w-100 ">
   <Button
  style={{
    backgroundColor: active === "" ? "#3761FF14" : "#0000000F",
    color: active === "" ? "#3761FF" : "#000000",
    border:active ===""? "1px solid #3761FF14": "1px solid #0000000F",
    fontWeight: active === "" ? 500 : 400,
    margin: "10px",
    borderRadius: "6px",
    fontSize:'14px'
  }}
  onClick={() => setActive("")}
>
  Tous
</Button>
    <Button
     style={{
        backgroundColor: active === true? "#EBFFEA" : "#0000000F",
        color: active === true ? "#349C32" : "#000000",
        border:active === true? "1px solid #EBFFEA": "1px solid #0000000F",
        fontWeight: active === true ? 500 : 400,
        margin: "10px",
        borderRadius: "6px",
        fontFamily:"Poppins",
        fontSize:'14px'
      }}
      onClick={() => setActive(true)}
    >
      Actif
    </Button>
    <Button
     style={{
        backgroundColor: active === false ? "#FFF0F0" : "#0000000F",
        color: active === false ? "#E32727" : "#000000",
        border:active === false? "1px solid #FFF0F0": "1px solid #0000000F",
        fontWeight: active === false ? 500 : 400,
        margin: "10px",
        borderRadius: "6px",
         fontFamily:"Poppins",
        fontSize:'14px'
      }}
      onClick={() => setActive(false)}
    >
      Inactif
    </Button>
  </ButtonGroup>
  </div>
   <div className=" ">
   <div className="d-flex align-items-center me-3">
    <label className=" mb-0 me-2 lanel">Statut</label>
    <div style={{ width: "100%", border:'1px solid #0000001A' }}></div>
  </div>
  <ButtonGroup className="w-100 ">
   <Button
  style={{
    backgroundColor: kycVerified === "" ? "#3761FF14" : "#0000000F",
    color: kycVerified === "" ? "#3761FF" : "#000000",
    border:kycVerified ===""? "1px solid #3761FF14": "1px solid #0000000F",
    fontWeight: kycVerified === "" ? 500 : 400,
    margin: "10px",
    borderRadius: "6px",
    fontSize:'14px'
  }}
  onClick={() => setKycVerified("")}
>
  Tous
</Button>
    <Button
     style={{
        backgroundColor: kycVerified === true? "#EBFFEA" : "#0000000F",
        color: kycVerified === true ? "#349C32" : "#000000",
        border:kycVerified === true? "1px solid #EBFFEA": "1px solid #0000000F",
        fontWeight: kycVerified === true ? 500 : 400,
        margin: "10px",
        borderRadius: "6px",
        fontFamily:"Poppins",
        fontSize:'14px'
      }}
      onClick={() => setKycVerified(true)}
    >
      Kyc activé
    </Button>
    <Button
     style={{
        backgroundColor: kycVerified === false ? "#FFF0F0" : "#0000000F",
        color: kycVerified === false ? "#E32727" : "#000000",
        border:kycVerified === false? "1px solid #FFF0F0": "1px solid #0000000F",
        fontWeight: kycVerified === false ? 500 : 400,
        margin: "10px",
        borderRadius: "6px",
         fontFamily:"Poppins",
        fontSize:'14px'
      }}
      onClick={() => setKycVerified(false)}
    >
      Kyc désactivé
    </Button>
  </ButtonGroup>
  </div>
  <div className="mb-3">
  <div className="d-flex align-items-center me-3">
    <label className="mb-0 me-2 lanel">
      Solde disponible
    </label>
    <div style={{ width: "100%", border: "1px solid #0000001A" }} />
  </div>

  <div className="d-flex gap-2 mt-3">
    <Input
      type="number"
      placeholder="Montant min"
      value={minBalance}
      onChange={(e) => setMinBalance(e.target.value)}
    />

    <Input
      type="number"
      placeholder="Montant max"
      value={maxBalance}
      onChange={(e) => setMaxBalance(e.target.value)}
    />
  </div>
</div>
   <div className=" ">
   <div className="d-flex align-items-center me-3">
    <label className=" mb-0 me-2 lanel">Statut kyc</label>
    <div style={{ width: "100%", border:'1px solid #0000001A' }}></div>
  </div>
  <ButtonGroup className="w-100 ">
   <Button
  style={{
    backgroundColor: kycStatus === "NOT_SUBMITTED" ? "#3761FF14" : "#0000000F",
    color: kycStatus === "NOT_SUBMITTED" ? "#3761FF" : "#000000",
    border:kycStatus ==="NOT_SUBMITTED"? "1px solid #3761FF14": "1px solid #0000000F",
    fontWeight: kycStatus === "NOT_SUBMITTED" ? 500 : 400,
    margin: "10px",
    borderRadius: "6px",
    fontSize:'14px',
     fontFamily:"Poppins"
  }}
  onClick={() => setKycStatus("NOT_SUBMITTED")}
>
  Non soumis
</Button>
    <Button
     style={{
        backgroundColor: kycStatus === "APPROVED"? "#EBFFEA" : "#0000000F",
        color: kycStatus === "APPROVED" ? "#349C32" : "#000000",
        border:kycStatus === "APPROVED"? "1px solid #EBFFEA": "1px solid #0000000F",
        fontWeight: kycStatus === "APPROVED" ? 500 : 400,
        margin: "10px",
        borderRadius: "6px",
        fontFamily:"Poppins",
        fontSize:'14px'
      }}
      onClick={() => setKycStatus("APPROVED")}
    >
      Approuvé
    </Button>
    <Button
     style={{
        backgroundColor: kycStatus === "SUBMITTED" ? "#FFF8DC" : "#0000000F",
        color: kycStatus === "SUBMITTED" ? "#FF7F29" : "#000000",
        border:kycStatus === "SUBMITTED"? "1px solid #FFF8DC": "1px solid #0000000F",
        fontWeight: kycStatus === "SUBMITTED" ? 500 : 400,
        margin: "10px",
        borderRadius: "6px",
        fontFamily:"Poppins",
        fontSize:'14px'
      }}
      onClick={() => setKycStatus("SUBMITTED")}
    >
      En attente
    </Button>
    <Button
     style={{
        backgroundColor: kycStatus === "REJECTED" ? "#FFF0F0" : "#0000000F",
        color: kycStatus === "REJECTED" ? "#E32727" : "#000000",
        border:kycStatus === "REJECTED"? "1px solid #FFF0F0": "1px solid #0000000F",
        fontWeight: kycStatus === "REJECTED" ? 500 : 400,
        margin: "10px",
        borderRadius: "6px",
        fontFamily:"Poppins",
        fontSize:'14px'
      }}
      onClick={() => setKycStatus("REJECTED")}
    >
      Rejecté
    </Button>

  </ButtonGroup>
  </div>
       <div className="mb-3">
         <div className="d-flex align-items-center me-3">
        <label className=" mb-0 me-2 lanel">Date de création</label>
        <div style={{ width: "100%", border:'1px solid #0000001A' }}></div>
      </div>
      <div className="col-4" style={{margin:"10px"}}>

        <FormGroup>
        <Input
          type="date"
          value={createdDate}
          onChange={(e) => setCreatedDate(e.target.value)}
        />
      </FormGroup>
      </div>
       </div> 
       <Button
  className="button apply-filter-btn"
  onClick={applyFilters}
>
  Appliquer le filtre
</Button>
</ModalBody>
</Modal>
  );
};

export default FiltrerMerchentModal;
